export const clientWorkSteps = [
  {
    stepNumber: 1,
    title: "Browse Services",
    description:
      "Explore a wide range of categories to find exactly what you need.",
  },
  {
    stepNumber: 2,
    title: "Connect with Experts",
    description:
      "Choose from verified professionals based on ratings and reviews.",
  },
  {
    stepNumber: 3,
    title: "Book and Pay Securely",
    description: "Schedule your service and make secure payments with ease.",
  },
  {
    stepNumber: 4,
    title: "Relax and Enjoy",
    description:
      "Sit back while the experts handle your task professionally and efficiently.",
  },
];

export const taskerWorkSteps = [
  {
    stepNumber: 1,
    title: "Sign In or Create Account",
    description: "Create your profile and list your skills",
  },
  {
    stepNumber: 2,
    title: "Find Tasks",
    description: "Browse tasks that match your expertise and location.",
  },
  {
    stepNumber: 3,
    title: "Complete Tasks",
    description: "Deliver excellent service and earn positive reviews.",
  },
  {
    stepNumber: 4,
    title: "Get Paid Securely",
    description: "Receive secure payments directly into your account.",
  },
];

export const clientFeatures = [
  {
    title: "Safe and secure payments",
    description:
      "Enjoy peace of mind with fast, reliable, and secure payment options.",
  },
  {
    title: "Verified professionals",
    description:
      "Connect with thoroughly vetted, skilled experts you can rely on.",
  },
  {
    title: "Wide range of services",
    description:
      "From home repairs to tech solutions, find everything you need in one place.",
  },
  {
    title: "Trusted ratings and reviews",
    description:
      "Make smart choices with honest feedback from satisfied users.",
  },
];

export const taskerFeatures = [
  {
    title: "Secure Payments",
    description:
      "Receive payments directly into your account, effortlessly and securely.",
  },
  {
    title: "Larger Client Network",
    description:
      "Get connected to hundreds of clients actively seeking skilled professionals.",
  },
  {
    title: "Flexible Working Hours",
    description: "Work on your own schedule and choose tasks that suit you.",
  },
  {
    title: "Real-time Notifications",
    description:
      "Never miss an opportunity with instant updates on new tasks and messages.",
  },
];
